import * as React from 'react';
import * as styles from './StructureViewer.css';
import { IStructureElement, IStructureElementAction } from './IStructureElement';
import { IAIcon } from '../icon/Icon';

export interface IStructureViewerElementProps {
  element: IStructureElement;
  index: number;
  parentChildrenCount: number;
  isTopLevel: boolean;
  indentation: number;
  highlightColor: string;
  elementActions: IStructureElementAction[];
}

export interface IStructureViewerElementState {
  expandEditMenu: boolean;
}

export default class StructureViewerElement extends React.Component<IStructureViewerElementProps, IStructureViewerElementState> {
  private menuRef: HTMLDivElement;

  constructor(props) {
    super(props);
    this.state = {
      expandEditMenu: false
    }
  }

  public componentDidMount() {
    document.addEventListener('mousedown', (e) => this.handleClick(e))
  }

  public componentWillUnmount() {
    document.removeEventListener('mousedown', (e) => this.handleClick(e));
  }

  private handleClick(event: MouseEvent) {
    if (this.state.expandEditMenu) {
      if (this.menuRef && !this.menuRef.contains(event.target as Node)) {
        this.setState({ expandEditMenu: false })
      }
    }
  }

  private getStructureHeight(items: IStructureElement[], height: number, indentation: number): number {
    let groupHeight = height;
    items.forEach((item, index) => {
      if (item.children?.length > 0 && (items.length - 1 !== index || indentation !== this.props.indentation)) {
        groupHeight = this.getStructureHeight(item.children, groupHeight, indentation + 1);
      }
      groupHeight = groupHeight + 45;
    });
    return groupHeight;
  }

  public render(): JSX.Element {
    let treeHeight = this.props.element?.children?.length > 0 ? (this.getStructureHeight(this.props.element.children, 0, this.props.indentation) - 20) : 0
    return <>
      <div className={styles.IA_elementWrapper}>
        <div
          className={styles.IA_element}
          style={{
            marginLeft: this.props.indentation * 50,
          }}
        >
          {treeHeight > 0 &&
            <div
              className={styles.IA_verticalIndentMarker}
              style={{
                height: treeHeight
              }}
            />
          }
          {this.props.indentation > 0 &&
            <div className={styles.IA_indentMarker} />
          }
          <IAIcon
            title={this.props.element.iconUrl}
            color={"#333333"}
            size={17}
            style={{
              marginRight: 8,
              marginTop: 2
            }}
          />
          <div
            className={styles.IA_title}
            style={{
              fontWeight: this.props.element.highlighted ? "bold" : "normal"
            }}
          >
            {this.props.element.title}
            {this.props.element.titleSubcomponent}
          </div>

        </div>
        {this.props.elementActions?.length > 0 &&
          <div
            style={{
              position: "relative"
            }}
            ref={ref => this.menuRef = ref}
          >
            <IAIcon
              title={"More"}
              color={this.props.highlightColor}
              size={17}
              onClick={() => {
                this.setState({ expandEditMenu: !this.state.expandEditMenu });
              }}
              style={{ marginLeft: 8, marginTop: 8, cursor: "pointer" }}
            />
            {this.state.expandEditMenu &&
              <ul className={styles.IA_cardBarItems}
              >
                {this.props.elementActions.map(elementAction => {
                  if (!elementAction.isEnabled({
                    element: this.props.element,
                    index: this.props.index,
                    isTopLevel: this.props.isTopLevel,
                    parentChildrenCount: this.props.parentChildrenCount
                  })) {
                    return <></>;
                  }

                  return <div
                    className={styles.IA_commandBarItem}
                    onClick={() => {
                      this.setState({ expandEditMenu: false }, () => {
                        elementAction.action(this.props.element);
                      });
                    }}
                  >
                    <IAIcon
                      url={elementAction.iconUrl}
                      size={14}
                      color={this.props.highlightColor}
                      style={{
                        float: "left",
                      }}
                    />
                    <div
                      style={{
                        color: "#333333",
                        marginLeft: 7,
                      }}
                    >
                      {elementAction.actionTitle({ isHighlighted: this.props.element.highlighted })}
                    </div>
                  </div>
                })}
              </ul>
            }
          </div>
        }
      </div>
      {this.props.element?.children?.map((child, i) => {
        return <StructureViewerElement
          element={child}
          indentation={this.props.indentation + 1}
          highlightColor={this.props.highlightColor}
          elementActions={this.props.elementActions}
          index={i}
          parentChildrenCount={this.props.element.children.length}
          isTopLevel={false}
        />
      })}
    </>
  }
}